import api from "./api";

/**
 * Reports Service
 *
 * API service for the Advanced Finance Reports module.
 * Handles all report generation, drill-down, export, configuration,
 * scheduling, and history operations.
 */
const reportsService = {
  // Dashboard
  getDashboard: () => api.get("/reports/dashboard"),

  // Report Generation
  getAccountLedger: (params) => api.get("/reports/account-ledger", { params }),
  getBudgetReport: (params) => api.get("/reports/budget-report", { params }),
  getTransactionList: (params) =>
    api.get("/reports/transaction-list", { params }),
  getProfitLoss: (params) => api.get("/reports/profit-loss", { params }),
  getBalanceSheet: (params) => api.get("/reports/balance-sheet", { params }),
  getCashFlow: (params) => api.get("/reports/cash-flow", { params }),

  // Drill-Down
  getDrillDownTransactions: (params) =>
    api.get("/reports/drill-down/transactions", { params }),
  getJournalEntryDetails: (id) =>
    api.get(`/reports/drill-down/journal-entry/${id}`),
  getSourceDocument: (type, id) =>
    api.get(`/reports/drill-down/source/${type}/${id}`),

  // Export
  exportToPDF: (data) => api.post("/reports/export/pdf", data),
  exportToExcel: (data) => api.post("/reports/export/excel", data),
  downloadExport: (id) =>
    api.get(`/reports/export/download/${id}`, { responseType: "blob" }),

  // Configurations
  getConfigurations: (params) => api.get("/reports/configurations", { params }),
  createConfiguration: (data) => api.post("/reports/configurations", data),
  updateConfiguration: (id, data) =>
    api.put(`/reports/configurations/${id}`, data),
  deleteConfiguration: (id) => api.delete(`/reports/configurations/${id}`),

  // Schedules
  getSchedules: () => api.get("/reports/schedules"),
  createSchedule: (data) => api.post("/reports/schedules", data),
  updateSchedule: (id, data) => api.put(`/reports/schedules/${id}`, data),
  deleteSchedule: (id) => api.delete(`/reports/schedules/${id}`),
  pauseSchedule: (id) => api.post(`/reports/schedules/${id}/pause`),
  resumeSchedule: (id) => api.post(`/reports/schedules/${id}/resume`),
  getScheduleHistory: (id, params) =>
    api.get(`/reports/schedules/${id}/history`, { params }),

  // History
  getHistory: (params) => api.get("/reports/history", { params }),

  // Access Log (admin only)
  getAccessLog: (params) => api.get("/reports/access-log", { params }),
};

export default reportsService;
